import * as Yup from "yup";
import AutoCompleteFormControl from "../../../components/formcontrols/AutoCompleteFormControl";
import ValidationErrorMessage from "../../../components/formcontrols/ValidationErrorMessage";
import { dateToyyyyMMdd } from "../../../util/date";
import { getPatchOperations } from "../../../util/form";
import IsRequired from "@/components/formcontrols/common/IsRequired";
import { validationMessages } from "@/constants/validation";
import { PersonForening } from "@/interfaces/schema";

export const personForeningForm = (
  personId: string,
  foreningQueryValues: IFormControlGenericQueryValues,
  personForening?: PersonForening,
): FormConfig<PersonForeningDTO> => {
  const personForeningId = personForening?.id;

  return {
    title: "medlemskab",
    lockedValues: [
      {
        id: "personId",
        value: personId,
      },
      {
        id: "personForeningId",
        value: personForeningId,
      },
    ],
    validationSchema: Yup.object({
      foreningId: Yup.string().required("Forening skal være sat"),
      periodeFraDato: Yup.date().nullable().required("Startdato skal være sat"),
      periodeTilDatoInklusiv: Yup.date()
        .nullable()
        .transform((_currValue, originalValue) =>
          originalValue === null || originalValue === ""
            ? null
            : new Date(originalValue),
        )
        .test(
          "dateEndBeforeStart",
          validationMessages.dateEndBeforeStart,
          function () {
            const { periodeFraDato, periodeTilDatoInklusiv } = this.parent;
            if (!periodeTilDatoInklusiv) return true;
            return periodeTilDatoInklusiv >= periodeFraDato;
          },
        ),
    }),
    form: [
      {
        component: "custom",
        customComponent: ({ touched, value, error, onChange }) => {
          return (
            <>
              <label className="form-label">
                Forening <IsRequired />
              </label>
              <AutoCompleteFormControl
                className={touched && error ? "is-invalid" : ""}
                onChange={onChange}
                value={value}
                queryValues={foreningQueryValues}
              />
              <ValidationErrorMessage touched={touched} errorMessage={error} />
            </>
          );
        },
        id: "foreningId",
        label: "Forening",
        isRequired: true,
        initialValue: personForening ? personForening.foreningId : undefined,
      },
      {
        component: "datepicker",
        id: "periodeFraDato",
        label: "Startdato",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeTilDatoInklusiv",
        label: "Slutdato",
        initialValue: "",
      },
    ],
    get: `person/${personId}/foreninger/${personForeningId}`,
    patch(values: PersonForeningDTO) {
      const ops = getPatchOperations(values);
      return {
        query: `person/${personId}/foreninger/${personForeningId}`,
        body: JSON.stringify(ops),
      };
    },
    post(values: PersonForeningDTO) {
      const { periodeFraDato, periodeTilDatoInklusiv, foreningId } = values;
      return {
        query: `person/${personId}/foreninger/`,
        body: {
          foreningId,
          periodeFraDato: dateToyyyyMMdd(periodeFraDato),
          periodeTilDatoInklusiv: periodeTilDatoInklusiv
            ? dateToyyyyMMdd(periodeTilDatoInklusiv)
            : "9999-12-31",
        },
      };
    },
    delete() {
      return {
        query: `person/${personId}/foreninger/${personForeningId}`,
      };
    },
  };
};
